import React, { useState } from 'react';
import './ProjectsSection.css';

import projectImg1 from '../assets/project1.jpg';
import projectImg2 from '../assets/project2.jpg';
import projectImg3 from '../assets/project3.jpg';
import projectImg4 from '../assets/project4.jpg';

const ProjectsSection = () => {
  const projectsList = [
    "Branding y diseño de marca",
    "Desarrollo web (Landing pages, E-commerce, Web corporativa, Portafolios, Educativas)",
    "Aplicaciones móviles (Marketplace, Delivery, Educación, Corporativas)",
    "Puntos de venta (Diseño, Integración tecnológica, Experiencia de cliente)"
  ];

  const projectImages = [
    { id: 1, src: projectImg1, alt: 'Imagen de Proyecto de Branding' },
    { id: 2, src: projectImg2, alt: 'Imagen de Proyecto de Desarrollo Web' },
    { id: 3, src: projectImg3, alt: 'Imagen de Proyecto de Aplicación Móvil' },
    { id: 4, src: projectImg4, alt: 'Imagen de Proyecto de Punto de Venta' },
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      (prevIndex + 1) % projectImages.length
    );
  };

  const goToPrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      (prevIndex - 1 + projectImages.length) % projectImages.length
    );
  };

  return (
    <section id="proyectos" className="projects-section">
      <button className="know-more-section-btn">CONOCE MÁS</button>

      <h2>PROYECTOS</h2> 
      
      <div className="projects-content">
        <ul className="projects-list">
          {projectsList.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <div className="carousel-container">
         
          <button onClick={goToPrevImage} className="carousel-nav-btn prev">
            &#10094;
          </button>
          <div className="carousel-image-wrapper">
            <img
              src={projectImages[currentImageIndex].src}
              alt={projectImages[currentImageIndex].alt}
              className="carousel-image"
            />
          </div>
          <button onClick={goToNextImage} className="carousel-nav-btn next">
            &#10095;
          </button>
          <div className="carousel-dots">
            {projectImages.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;